import Membership from '../../types/Membership';

/**
 * Format team manager names for display.
 * - 0 managers: undefined
 * - 1-2 managers: "Alice, Bob"
 * - 3+ managers: "Alice and 2 others"
 */
export function formatManagerNames(managers: Membership[]): string | undefined {
  if (!managers || managers.length === 0) {
    return undefined;
  }

  if (managers.length === 1) {
    return managers[0].name;
  }

  if (managers.length === 2) {
    return `${managers[0].name}, ${managers[1].name}`;
  }

  // 3+ managers
  const othersCount = managers.length - 1;
  return `${managers[0].name} and ${othersCount} others`;
}

/**
 * Filter memberships to get only team managers (those with teamId in managedTeamIds).
 */
export function getTeamManagers(memberships: Membership[], teamId: string): Membership[] {
  return memberships.filter((m) => m.managedTeamIds?.includes(teamId));
}
